import * as React from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const DropdownWithFloatingLabelContext = /*#__PURE__*/React.createContext(null);
const useDropdownWithFloatingLabelContext = () => React.useContext(DropdownWithFloatingLabelContext);
const useNonNullishDropdownWithFloatingLabelContext = () => useNonNullishContext(DropdownWithFloatingLabelContext);
function useFloatingLabelProps(props) {
  const {
    id,
    className
  } = props;
  // communicate the id up to the DropdownWithFloatingLabel comp if necessary
  const withFloatingLabelContext = useDropdownWithFloatingLabelContext();
  const hasFloatingLabel = withFloatingLabelContext !== undefined;
  const setDropdownId = withFloatingLabelContext === null || withFloatingLabelContext === void 0 ? void 0 : withFloatingLabelContext.setDropdownId;
  React.useEffect(() => {
    if (setDropdownId === undefined) {
      return;
    }
    setDropdownId(id);
    return () => {
      setDropdownId(undefined);
    };
  }, [id, setDropdownId]);
  if (!hasFloatingLabel) {
    return props;
  }
  return _objectSpreadProps(_objectSpread({}, props), {
    className
  });
}
export { DropdownWithFloatingLabelContext, useDropdownWithFloatingLabelContext, useFloatingLabelProps, useNonNullishDropdownWithFloatingLabelContext };